module.exports = __webpack_public_path__ + "img/product4.a497d4fd.jpg";